export default __webpack_public_path__ + "static/img-mexc-global-6b86ab453fee9475cf88051cf8973d5b.png";